<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">운영보고서</span>
            <span class="txt">기존 데이터에서 중요한 정보를 한눈에 확인할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button @click="onClickRouter('/madmin/stats/month')">월간 보고서</button>
            <button @click="onClickRouter('/madmin/stats/period')">기간별 보고서</button>
            <button class="on">연간 보고서</button>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="[...yearList]"
                    :select-value="[...yearValueList]"
                    :selected-value="yearDate"
                    class="w130"
                    @update:set="(val) => (yearDate = val)"
                ></select-form>
                <div class="right">
                    <button class="com-btn excel" @click="execlDownload">엑셀 다운로드</button>
                </div>
            </div>
        </div>

        <div class="com-table-top">
            <p class="sub-title bold">상담</p>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>전화</th>
                        <th>방문</th>
                        <th>기타</th>
                        <th>총 상담 수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>{{ yearDate }}년</strong>
                        </td>
                        <td>{{ consult.thisMonth.tel }}</td>
                        <td>{{ consult.thisMonth.visit }}</td>
                        <td>{{ consult.thisMonth.etc }}</td>
                        <td>
                            <strong>{{ consultTotal2 }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>{{ prevYearDate }}년</strong>
                        </td>
                        <td>{{ consult.prevMonth.tel }}</td>
                        <td>{{ consult.prevMonth.visit }}</td>
                        <td>{{ consult.prevMonth.etc }}</td>
                        <td>
                            <strong>{{ consultTotal }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top profit">
            <p class="sub-title bold">매출</p>
            <span class="title">
                전체 수익 현황
                <div class="com-tooltip right">
                    도움말
                    <button class="icon"></button>
                    <div class="detail big">
                        <div class="division-wrap">
                            <div class="info-area">
                                <span class="tit">소진금액</span>
                                <p class="txt">1회당 단가 x 사용횟수</p>
                                <span class="tit">잔여금액</span>
                                <p class="txt">
                                    해당 직원이 담당강사로 배정 된 유효 회원의 구매가에서
                                    <br />
                                    소진금액을 제외하고 남은 누적잔여금액의 총 합계.
                                    <br />
                                    <br />

                                    예시)
                                    <br />
                                    결제금액 : 10회 500,000원
                                    <br />
                                    회당 단가 50,000원
                                    <br />
                                    수업 3회 사용완료인 경우
                                    <br />
                                    소진매출 : 150,000원
                                    <br />
                                    잔여금액 : 350,000원
                                </p>
                                <p class="txt red">
                                    ※ 소진금액, 잔여금액은 이용권의 횟수가 기간제/무제한으로 설정된 경우 정확한 금액을
                                    환산할 수 없습니다. 해당 이용권이 포함되어있는 경우 정확하지 않을 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </span>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>이용권 수입</th>
                        <th>일반수입</th>
                        <th>환불</th>
                        <th class="gray">매출합계</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>{{ yearDate }}년</strong>
                        </td>
                        <td>{{ price.thisMonth.ticketIncome | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.income | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.refund | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalThisMonth | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>{{ prevYearDate }}년</strong>
                        </td>
                        <td>{{ price.prevMonth.ticketIncome | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.income | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.refund | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalPrevMonth | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="com-table w1080">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>고정지출</th>
                        <th>변동지출</th>
                        <th>급여</th>
                        <th class="gray">지출합계</th>
                        <th class="blue">영업이익</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>{{ yearDate }}년</strong>
                        </td>
                        <td>{{ price.thisMonth.fix | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.var | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.salary | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalThisMonth1 | numberFormatFilter }}</strong>
                        </td>
                        <td>
                            <strong>{{ thisMonthRealPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>{{ prevYearDate }}년</strong>
                        </td>
                        <td>{{ price.prevMonth.fix | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.var | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.salary | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalPrevMonth1 | numberFormatFilter }}</strong>
                        </td>
                        <td>
                            <strong>{{ prevMonthRealPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="com-table w540">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th class="blue"></th>
                        <th class="blue">이용권 소진금액</th>
                        <th class="blue">이용권 잔여금액</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>{{ yearDate }}년</strong>
                        </td>
                        <td>{{ price.thisMonth.used | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.remain | numberFormatFilter }}</td>
                    </tr>
                    <tr>
                        <td>
                            <strong>{{ prevYearDate }}년</strong>
                        </td>
                        <td>{{ price.prevMonth.used | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.remain | numberFormatFilter }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">신규 / 재등록 현황</span>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>신규건수</th>
                        <th>신규매출</th>
                        <th>재등록건수</th>
                        <th>재등록매출</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>{{ yearDate }}년</strong>
                        </td>
                        <td>{{ contractType.thisMonth.newContract }}</td>
                        <td>{{ contractType.thisMonth.newPrice | numberFormatFilter }}</td>
                        <td>{{ contractType.thisMonth.reContract }}</td>
                        <td>
                            <strong>{{ contractType.thisMonth.rePrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>{{ prevYearDate }}년</strong>
                        </td>
                        <td>{{ contractType.prevMonth.newContract }}</td>
                        <td>{{ contractType.prevMonth.newPrice | numberFormatFilter }}</td>
                        <td>{{ contractType.prevMonth.reContract }}</td>
                        <td>
                            <strong>{{ contractType.prevMonth.rePrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">
                결제수단별 상품매출
                <small>(이용권 수입 + 일반 수업)</small>
            </span>
            <table class="com-table layout-fixed">
                <thead>
                    <tr>
                        <th></th>
                        <th>핏페이</th>
                        <th>카드</th>
                        <th>현금</th>
                        <th>계좌</th>
                        <th>기타</th>
                        <th class="gray">합계</th>
                        <th>마일리지 사용</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>{{ yearDate }}년</strong>
                        </td>
                        <td>{{ payType.thisMonth.fitpay | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.card | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.cash | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.bank | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.etc | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ payTypeTotal2 | numberFormatFilter }}</strong>
                        </td>
                        <td>{{ payType.thisMonth.mileage | numberFormatFilter }}</td>
                    </tr>
                    <tr>
                        <td>
                            <strong>{{ prevYearDate }}년</strong>
                        </td>
                        <td>{{ payType.prevMonth.fitpay | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.card | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.cash | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.bank | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.etc | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ payTypeTotal | numberFormatFilter }}</strong>
                        </td>
                        <td>{{ payType.prevMonth.mileage | numberFormatFilter }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">이용권 구분별 매출현황</span>
            <table class="com-table">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>개인</th>
                        <th>듀엣</th>
                        <th>오티</th>
                        <th>그룹</th>
                        <th>쿠폰</th>
                        <th>회원권</th>
                        <th>운동복</th>
                        <!-- <th>패키지</th> -->
                        <th class="gray">합계</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <strong>{{ yearDate }}년</strong>
                        </td>
                        <td>{{ ticketType.thisMonth.person | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.duet | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.ot | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.group | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.coupon | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.ticket | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.sport | numberFormatFilter }}</td>
                        <!-- <td>{{ticketType.thisMonth.pakage | numberFormatFilter}}</td> -->
                        <td>
                            <strong>{{ ticketType.thisMonth.totalPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>{{ prevYearDate }}년</strong>
                        </td>
                        <td>{{ ticketType.prevMonth.person | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.duet | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.ot | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.group | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.coupon | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.ticket | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.sport | numberFormatFilter }}</td>
                        <!-- <td>{{ticketType.prevMonth.pakage | numberFormatFilter}}</td> -->
                        <td>
                            <strong>{{ ticketType.prevMonth.totalPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">환불현황</span>
            <table class="com-table w480">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>총 건수</th>
                        <th>금액</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ yearDate }}년</td>
                        <td>{{ refund.thisYear.cnt | numberFormatFilter }}</td>
                        <td>{{ refund.thisYear.price | numberFormatFilter }}</td>
                    </tr>
                    <tr>
                        <td>{{ prevYearDate }}년</td>
                        <td>{{ refund.prevYear.cnt | numberFormatFilter }}</td>
                        <td>{{ refund.prevYear.price | numberFormatFilter }}</td>
                    </tr>
                </tbody>
            </table>
            <p class="sub-title bold">직원</p>
            <div class="check-line">
                <div class="com-check">
                    <input
                        id="select-check-1-1"
                        v-model="sign"
                        name="select-check-1"
                        type="checkbox"
                        value="I"
                        @change="onMonthStaffBill"
                    />
                    <label for="select-check-1-1">근무중인 직원</label>
                </div>
                <div class="com-check">
                    <input
                        id="select-check-1-2"
                        v-model="resign"
                        name="select-check-1"
                        type="checkbox"
                        value="O"
                        @change="onMonthStaffBill"
                    />
                    <label for="select-check-1-2">퇴사한 직원</label>
                </div>
                <div class="com-tooltip right">
                    도움말
                    <button class="icon"></button>
                    <div class="detail big gap">
                        <div class="division-wrap">
                            <div class="info-area">
                                <span class="tit">소진금액</span>
                                <p class="txt">1회당 단가 x 사용횟수</p>
                                <span class="tit">잔여금액</span>
                                <p class="txt">
                                    해당 직원이 담당강사로 배정 된 유효 회원의 구매가에서
                                    <br />
                                    소진금액을 제외하고 남은 누적잔여금액의 총 합계.
                                </p>
                                <span class="tit">유효건수</span>
                                <p class="txt">해당직원이 ‘담당강사’로 선택된 이용권 중 유효한 이용권 건수</p>
                                <span class="tit">종료건수</span>
                                <p class="txt">
                                    해당직원이 ‘담당강사’로 선택된 이용권 중 해당 기간에
                                    <br />
                                    종료된 이용권 건수 (종료 후 재등록 여부와는 상관 없음)
                                </p>
                                <p class="txt red">
                                    ※ 소진금액, 잔여금액은 이용권의 횟수가 기간제/무제한으로 설정된 경우 정확한 금액을
                                    환산할 수 없습니다. 해당 이용권이 포함되어있는 경우 정확하지 않을 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 180px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>직원명</th>
                        <th>년</th>
                        <th>총 매출</th>
                        <th>신규매출</th>
                        <th>재등록 매출</th>
                        <th>소진금액</th>
                        <th>잔여금액</th>
                        <th>유효건수</th>
                        <th>종료건수</th>
                        <th>신규건수</th>
                        <th>재등록 건수</th>
                        <th>총 수업 수</th>
                        <th>차인 지급액</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(monthList, staffIndex) in staffStatList">
                        <tr v-for="(m, mIdx) in monthList" :key="`${staffIndex}_${mIdx}`">
                            <td v-if="mIdx === 0" :rowspan="monthList.length > 1 && mIdx === 0 ? monthList.length : ''">
                                {{ m.name }}
                            </td>
                            <td>{{ m.year }}</td>
                            <td>{{ m.totalPrice | numberFormatFilter }}</td>
                            <td>{{ m.newPrice | numberFormatFilter }}</td>
                            <td>{{ m.rePrice | numberFormatFilter }}</td>
                            <td>{{ m.usePrice | numberFormatFilter }}</td>
                            <td>{{ m.remainCnt | numberFormatFilter }}</td>
                            <td>{{ m.valid }}</td>
                            <td>{{ m.end }}</td>
                            <td>{{ m.new }}</td>
                            <td>{{ m.re }}</td>
                            <td>{{ m.totalLesson }}</td>
                            <td>{{ m.realPrice | numberFormatFilter }}</td>
                        </tr>
                    </template>

                    <!-- <tr>
                    <td>{{prevYearDate}}년</td>
                    <td>{{p.totalSalePrice | numberFormatFilter}}</td>
                    <td>{{p.saleNewPrice | numberFormatFilter}}</td>
                    <td>{{p.saleRenewPrice | numberFormatFilter}}</td>
                    <td>{{p.tickUsePrice | numberFormatFilter}}</td>
                    <td>{{p.realSalePrice | numberFormatFilter}}</td>
                    <td>{{p.lessValidCnt}}</td>
                    <td>{{p.lessFinishCnt}}</td>
                    <td>{{p.saleNewCnt}}</td>
                    <td>{{p.saleRenewCnt}}</td>
                    <td>{{p.lessTotalCnt}}</td>
                    <td>{{p.realSalePrice | numberFormatFilter}}</td>
                </tr> -->
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import XLSX from 'xlsx';
import { numberFormat } from '@/assets/js/excelCommon.js';

export default {
    name: 'StatsYear',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        consultTotal: function () {
            // 상담 전년
            return (
                parseInt(this.consult.prevMonth.tel) +
                parseInt(this.consult.prevMonth.visit) +
                parseInt(this.consult.prevMonth.etc)
            );
        },
        consultTotal2: function () {
            // 상담 이번년
            return (
                parseInt(this.consult.thisMonth.tel) +
                parseInt(this.consult.thisMonth.visit) +
                parseInt(this.consult.thisMonth.etc)
            );
        },
        saleTotalThisMonth: function () {
            // 매출당월
            return (
                parseInt(this.price.thisMonth.ticketIncome) +
                parseInt(this.price.thisMonth.income) +
                parseInt(this.price.thisMonth.refund)
            );
        },
        saleTotalThisMonth1: function () {
            //매출전월
            return (
                parseInt(this.price.thisMonth.fix) +
                parseInt(this.price.thisMonth.var) +
                parseInt(this.price.thisMonth.salary)
            );
        },
        saleTotalPrevMonth: function () {
            //매출당월
            return (
                parseInt(this.price.prevMonth.ticketIncome) +
                parseInt(this.price.prevMonth.income) +
                parseInt(this.price.prevMonth.refund)
            );
        },
        saleTotalPrevMonth1: function () {
            //매출전월
            return (
                parseInt(this.price.prevMonth.fix) +
                parseInt(this.price.prevMonth.var) +
                parseInt(this.price.prevMonth.salary)
            );
        },
        thisMonthRealPrice: function () {
            // 순수매출
            return this.saleTotalThisMonth - this.saleTotalThisMonth1;
        },
        prevMonthRealPrice: function () {
            // 순수매출
            return this.saleTotalPrevMonth - this.saleTotalPrevMonth1;
        },
        payTypeTotal: function () {
            return (
                this.payType.prevMonth.fitpay +
                this.payType.prevMonth.card +
                this.payType.prevMonth.cash +
                this.payType.prevMonth.bank +
                this.payType.prevMonth.etc +
                this.payType.prevMonth.mileage
            );
        },
        payTypeTotal2: function () {
            return (
                this.payType.thisMonth.fitpay +
                this.payType.thisMonth.card +
                this.payType.thisMonth.cash +
                this.payType.thisMonth.bank +
                this.payType.thisMonth.etc +
                this.payType.thisMonth.mileage
            );
        },
    },
    watch: {
        yearDate: function (newValue) {
            console.log(newValue);
            this.yearDate = newValue;
            this.prevYearDate = moment(this.yearDate).subtract(1, 'years').format('YYYY');
            console.log(this.yearDate);
            this.init();
        },
    },
    data() {
        return {
            centerId: '',
            yearList: [],
            yearValueList: [],
            yearDate: moment().format('YYYY'),
            prevYearDate: moment(this.yearDate).subtract(1, 'years').format('YYYY'),
            sign: true,
            resign: true,

            ticketType: {
                prevMonth: {
                    person: 0,
                    duet: 0,
                    ot: 0,
                    group: 0,
                    coupon: 0,
                    ticket: 0,
                    totalPrice: 0,
                },
                thisMonth: {
                    person: 0,
                    duet: 0,
                    ot: 0,
                    group: 0,
                    coupon: 0,
                    ticket: 0,
                    totalPrice: 0,
                },
            },
            payType: {
                prevMonth: {
                    fitpay: 0,
                    card: 0,
                    cash: 0,
                    bank: 0,
                    etc: 0,
                    mileage: 0,
                },
                thisMonth: {
                    fitpay: 0,
                    card: 0,
                    cash: 0,
                    bank: 0,
                    etc: 0,
                    mileage: 0,
                },
            },
            contractType: {
                prevMonth: {
                    newContract: 0,
                    newPrice: 0,
                    reContract: 0,
                    rePrice: 0,
                },
                thisMonth: {
                    newContract: 0,
                    newPrice: 0,
                    reContract: 0,
                    rePrice: 0,
                },
            },
            consult: {
                prevMonth: {
                    tel: 0,
                    visit: 0,
                    etc: 0,
                },
                thisMonth: {
                    tel: 0,
                    visit: 0,
                    etc: 0,
                },
            },
            price: {
                prevMonth: {
                    //이용권수입
                    ticketIncome: 0,
                    //일반수입
                    income: 0,
                    //환불
                    refund: 0,
                    //고정지출
                    fix: 0,
                    //변동지출
                    var: 0,
                    //급여
                    salary: 0,
                    //영업이익
                    sale: 0,
                    //이용권소진금액
                    used: 0,
                    //이용권잔여금액
                    remain: 0,
                },
                thisMonth: {
                    //이용권수입
                    ticketIncome: 0,
                    //일반수입
                    income: 0,
                    //환불
                    refund: 0,
                    //고정지출
                    fix: 0,
                    //변동지출
                    var: 0,
                    //급여
                    salary: 0,
                    //영업이익
                    sale: 0,
                    //이용권소진금액
                    used: 0,
                    //이용권잔여금액
                    remain: 0,
                },
            },
            //환불현황
            refund: {
                thisYear: {
                    cnt: 0,
                    price: 0,
                },
                prevYear: {
                    cnt: 0,
                    price: 0,
                },
            },
            staffStatList: [],
            billStatus: 'T', //초기값
        };
    },
    mounted() {
        this.centerId = this.cId; //센터id
        this.init();
    },
    methods: {
        //초기화
        async init() {
            try {
                await this.onYearConsult(); //이번년도
                await this.onYearConsultType();
                await this.onYearPayType();
                await this.onYearTicketType();
                await this.onYearSaleStat();
                await this.onReturnStat();
                //await this.onPrevYearSaleStat(); // 작년 매출 조회
                //await this.onPrevReturnStat(); // 작년 매출 현황 조회
                await this.onMonthStaffBill(); // 직원통계

                //년도 자동생성
                for (let i = 0; i < 6; i++) {
                    this.yearList.push(moment().subtract(i, 'y').format('YYYY년'));
                    this.yearValueList.push(moment().subtract(i, 'y').format('YYYY'));
                }
            } catch (error) {
                console.log(error);
                console.log('초기화 오류입니다.');
            }
        },
        //상담조회
        async onYearConsult() {
            try {
                const thisYear = await this.getYearConsult(this.yearDate);
                console.log('상담조회 데이터', thisYear.data);
                const { thisMonth } = this.consult;
                thisMonth.tel = 0; // 초기화
                thisMonth.visit = 0; // 초기화
                thisMonth.etc = 0; // 초기화
                thisYear.data.forEach((g) => {
                    if (g.cc_consult_path == 'T') {
                        //전화
                        this.consult.thisMonth.tel += parseInt(g.cc_consult_cnt);
                    } else if (g.cc_consult_path == 'V') {
                        //방문
                        this.consult.thisMonth.visit += parseInt(g.cc_consult_cnt);
                    } else if (g.cc_consult_path == 'E') {
                        //기타
                        this.consult.thisMonth.etc += parseInt(g.cc_consult_cnt);
                    }
                });

                const prevYear = await this.getYearConsult(moment(this.yearDate).subtract(1, 'years').format('YYYY'));
                console.log('작년데이터', prevYear.data);
                const { prevMonth } = this.consult;
                prevMonth.tel = 0;
                prevMonth.visit = 0;
                prevMonth.etc = 0;
                prevYear.data.forEach((g) => {
                    if (g.cc_consult_path == 'T') {
                        //전화
                        this.consult.prevMonth.tel += parseInt(g.cc_consult_cnt);
                    } else if (g.cc_consult_path == 'V') {
                        //방문
                        this.consult.prevMonth.visit += parseInt(g.cc_consult_cnt);
                    } else if (g.cc_consult_path == 'E') {
                        //기타
                        this.consult.prevMonth.etc += parseInt(g.cc_consult_cnt);
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //상담조회 api
        getYearConsult(year) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/year/consult`, {
                params: {
                    year: year,
                },
            });
        },
        //신규 재등록조회
        async onYearConsultType() {
            try {
                const thisYear = await this.getYearConsultType(this.yearDate);
                console.log('신규 재등록조회', thisYear.data);
                const { contractType } = this;
                contractType.prevMonth.newContract = 0;
                contractType.prevMonth.newPrice = 0;
                contractType.prevMonth.reContract = 0;
                contractType.prevMonth.rePrice = 0;
                contractType.thisMonth.newContract = 0;
                contractType.thisMonth.newPrice = 0;
                contractType.thisMonth.reContract = 0;
                contractType.thisMonth.rePrice = 0;

                thisYear.data.forEach((g) => {
                    if (g.cc_contract_type_cd == 'N') {
                        this.contractType.thisMonth.newContract += parseInt(g.cc_contract_type_cd_cnt);
                        this.contractType.thisMonth.newPrice += parseInt(g.cc_total_buy_price);
                    } else if (g.cc_contract_type_cd == 'R') {
                        this.contractType.thisMonth.reContract += parseInt(g.cc_contract_type_cd_cnt);
                        this.contractType.thisMonth.rePrice += parseInt(g.cc_total_buy_price);
                    }
                });
                const prevYear = await this.getYearConsultType(
                    moment(this.yearDate).subtract(1, 'years').format('YYYY')
                );
                console.log('재등록', prevYear.data);
                prevYear.data.forEach((g) => {
                    if (g.cc_contract_type_cd == 'N') {
                        this.contractType.prevMonth.newContract += parseInt(g.cc_contract_type_cd_cnt);
                        this.contractType.prevMonth.newPrice += parseInt(g.cc_total_buy_price);
                    } else if (g.cc_contract_type_cd == 'R') {
                        this.contractType.prevMonth.reContract += parseInt(g.cc_contract_type_cd_cnt);
                        this.contractType.prevMonth.rePrice += parseInt(g.cc_total_buy_price);
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //신규 재등록조회 api
        getYearConsultType(year) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/year/contract-type`, {
                params: {
                    year: year,
                },
            });
        },
        //결제수단별 상품매출 조회
        async onYearPayType() {
            try {
                const thisYear = await this.getYearPayType(this.yearDate);
                const { thisMonth } = this.payType;
                thisMonth.card = 0;
                thisMonth.cash = 0;
                thisMonth.bank = 0;
                thisMonth.etc = 0;
                thisMonth.mileage = 0;
                thisMonth.fitpay = 0;

                console.log('결제수단 조회', thisYear);
                thisYear.data.forEach((g) => {
                    if (g.ccb_pay_type_cd == 'C') {
                        //카드
                        this.payType.thisMonth.card += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'L') {
                        //현금
                        this.payType.thisMonth.cash += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'B') {
                        //계좌이체
                        this.payType.thisMonth.bank += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'E') {
                        //기타
                        this.payType.thisMonth.etc += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'M') {
                        //마일리지
                        this.payType.thisMonth.mileage += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'T' || g.ccb_pay_type_cd == 'U') {
                        //핏페이
                        this.payType.thisMonth.fitpay += parseInt(g.ccb_bill_price);
                    }
                });

                const prevYear = await this.getYearPayType(moment(this.yearDate).subtract(1, 'years').format('YYYY'));
                const { prevMonth } = this.payType;
                prevMonth.card = 0;
                prevMonth.cash = 0;
                prevMonth.bank = 0;
                prevMonth.etc = 0;
                prevMonth.mileage = 0;
                prevMonth.fitpay = 0;

                console.log('결제수단 전달', prevYear);
                prevYear.data.forEach((g) => {
                    if (g.ccb_pay_type_cd == 'C') {
                        //카드
                        this.payType.prevMonth.card += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'L') {
                        //현금
                        this.payType.prevMonth.cash += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'B') {
                        //계좌이체
                        this.payType.prevMonth.bank += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'E') {
                        //기타
                        this.payType.prevMonth.etc += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'M') {
                        //마일리지
                        this.payType.prevMonth.mileage += parseInt(g.ccb_bill_price);
                    } else if (g.ccb_pay_type_cd == 'T' || g.ccb_pay_type_cd == 'U') {
                        //핏페이
                        this.payType.prevMonth.fitpay += parseInt(g.ccb_bill_price);
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //결제수단 조회 api
        getYearPayType(year) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/year/pay-type`, {
                params: {
                    year: year,
                },
            });
        },
        //이용권 구분별 매출현황 조회
        async onYearTicketType() {
            try {
                const thisYear = await this.getYearTicketType(this.yearDate);
                const { thisMonth } = this.ticketType;
                thisMonth.duet = 0;
                thisMonth.group = 0;
                thisMonth.ot = 0;
                thisMonth.person = 0;
                thisMonth.coupon = 0;
                thisMonth.ticket = 0;

                console.log('이용권조회', thisYear);
                thisYear.data.forEach((g) => {
                    if (g.ccp_ticket_type_cd == 'D') {
                        this.ticketType.thisMonth.duet += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'G') {
                        this.ticketType.thisMonth.group += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'O') {
                        this.ticketType.thisMonth.ot += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'P') {
                        this.ticketType.thisMonth.person += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'C') {
                        this.ticketType.thisMonth.coupon += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'T') {
                        this.ticketType.thisMonth.ticket += parseInt(g.ccp_total_bill_price);
                    }
                });

                const prevYear = await this.getYearTicketType(
                    moment(this.yearDate).subtract(1, 'years').format('YYYY')
                );
                const { prevMonth } = this.ticketType;
                prevMonth.duet = 0;
                prevMonth.group = 0;
                prevMonth.ot = 0;
                prevMonth.person = 0;
                prevMonth.coupon = 0;
                prevMonth.ticket = 0;
                console.log('이용권조회', prevYear);
                prevYear.data.forEach((g) => {
                    if (g.ccp_ticket_type_cd == 'D') {
                        this.ticketType.prevMonth.duet += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'G') {
                        this.ticketType.prevMonth.group += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'O') {
                        this.ticketType.prevMonth.ot += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'P') {
                        this.ticketType.prevMonth.person += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'C') {
                        this.ticketType.prevMonth.coupon += parseInt(g.ccp_total_bill_price);
                    } else if (g.ccp_ticket_type_cd == 'T') {
                        this.ticketType.prevMonth.ticket += parseInt(g.ccp_total_bill_price);
                    }
                });

                this.ticketType.prevMonth.totalPrice =
                    this.ticketType.prevMonth.person +
                    this.ticketType.prevMonth.duet +
                    this.ticketType.prevMonth.ot +
                    this.ticketType.prevMonth.group +
                    this.ticketType.prevMonth.coupon +
                    this.ticketType.prevMonth.ticket;

                this.ticketType.thisMonth.totalPrice =
                    this.ticketType.thisMonth.person +
                    this.ticketType.thisMonth.duet +
                    this.ticketType.thisMonth.ot +
                    this.ticketType.thisMonth.group +
                    this.ticketType.thisMonth.coupon +
                    this.ticketType.thisMonth.ticket;
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //이용권 조회 api
        getYearTicketType(year) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/year/ticket-type`, {
                params: {
                    year: year,
                },
            });
        },
        //매출 조회
        async onYearSaleStat() {
            try {
                const thisYear = await this.getYearSaleStat(this.yearDate);
                //올해
                const { thisMonth } = this.price;
                thisMonth.ticketIncome = 0; //초기화
                thisMonth.income = 0; // 초기화
                thisMonth.refund = 0; // 초기화
                thisMonth.fix = 0; // 초기화
                thisMonth.var = 0; // 초기화
                thisMonth.salary = 0; // 초기화
                thisMonth.sale = 0; // 초기화
                thisMonth.used = 0; // 초기화
                thisMonth.remain = 0; // 초기화
                console.log('매출조회', thisYear);
                thisYear.data.forEach((g) => {
                    this.price.thisMonth.ticketIncome += parseInt(g.css_tick_price);
                    this.price.thisMonth.income += parseInt(g.css_prod_price);
                    this.price.thisMonth.refund += parseInt(g.css_ret_price);
                    this.price.thisMonth.fix += parseInt(g.css_fix_exp_price);
                    this.price.thisMonth.var += parseInt(g.css_var_exp_price);
                    this.price.thisMonth.salary += parseInt(g.css_pay_price);
                    this.price.thisMonth.sale += parseInt(g.css_oper_profit_cnt);
                    this.price.thisMonth.used += parseInt(g.css_tick_exh_price);
                    this.price.thisMonth.remain += parseInt(g.css_tick_remain_price);
                });
                //작년
                const prevYear = await this.getYearSaleStat(moment(this.yearDate).subtract(1, 'years').format('YYYY'));
                const { prevMonth } = this.price;
                prevMonth.ticketIncome = 0; //초기화
                prevMonth.income = 0; // 초기화
                prevMonth.refund = 0; // 초기화
                prevMonth.fix = 0; // 초기화
                prevMonth.var = 0; // 초기화
                prevMonth.salary = 0; // 초기화
                prevMonth.sale = 0; // 초기화
                prevMonth.used = 0; // 초기화
                prevMonth.remain = 0; // 초기화
                console.log('전년도 매출조회', prevYear);
                prevYear.data.forEach((g) => {
                    this.price.prevMonth.ticketIncome += parseInt(g.css_tick_price);
                    this.price.prevMonth.income += parseInt(g.css_prod_price);
                    this.price.prevMonth.refund += parseInt(g.css_ret_price);
                    this.price.prevMonth.fix += parseInt(g.css_fix_exp_price);
                    this.price.prevMonth.var += parseInt(g.css_var_exp_price);
                    this.price.prevMonth.salary += parseInt(g.css_pay_price);
                    this.price.prevMonth.sale += parseInt(g.css_oper_profit_cnt);
                    this.price.prevMonth.used += parseInt(g.css_tick_exh_price);
                    this.price.prevMonth.remain += parseInt(g.css_tick_remain_price);
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },

        //매출조회 api
        getYearSaleStat(year) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/year/sale-stats`, {
                params: {
                    year: year,
                },
            });
        },
        //환불현황 조회 이번년
        async onReturnStat() {
            try {
                const thisYear = await this.getReturnStat(this.yearDate, this.yearDate);
                console.log('환불현황 데이터', thisYear.data);
                this.refund.thisYear.cnt = thisYear.data[0].cc_cnt;
                this.refund.thisYear.price = thisYear.data[0].cc_total_price;

                const prevYear = await this.getReturnStat(this.prevYearDate, this.prevYearDate);
                console.log('작년 환불현황 데이터', prevYear.data);
                this.refund.prevYear.cnt = prevYear.data[0].cc_cnt;
                this.refund.prevYear.price = prevYear.data[0].cc_total_price;
            } catch (error) {
                console.log(error);
                console.log('환불현황 오류입니다.');
            }
        },
        //환불현황 조회 API
        getReturnStat(startDate, endDate) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/sale/term/return-stats`, {
                params: {
                    startDate: startDate + '01',
                    endDate: endDate + '12',
                },
            });
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        async staffTotalStat(thisYear, prevYear) {
            try {
                /*
                [
                    [
                        {name:"강타",momth:"2021",...}
                        {name:"강타",month:"2020",...}
                    ]
                ]

                csbb_bill_year_month: "202101"
                csbb_center_staff_id: 39
                csbb_center_staff_nm: "강타"
                */

                console.log('의도', thisYear, prevYear);
                const array = [...prevYear, ...thisYear];
                console.log(array);

                let sum = {};
                for (let d of array) {
                    const id = d.csbb_center_staff_id;
                    if (sum[id] === undefined) {
                        sum[id] = [
                            {
                                year: this.yearDate,
                                id: d.csbb_center_staff_id,
                                name: d.csbb_center_staff_nm,
                                totalPrice: 0,
                                newPrice: 0,
                                rePrice: 0,
                                usePrice: 0,
                                remainCnt: 0,
                                valid: 0,
                                end: 0,
                                new: 0,
                                re: 0,
                                totalLesson: 0,
                                realPrice: 0,
                            },
                            {
                                year: this.prevYearDate,
                                id: d.csbb_center_staff_id,
                                name: d.csbb_center_staff_nm,
                                totalPrice: 0,
                                newPrice: 0,
                                rePrice: 0,
                                usePrice: 0,
                                remainCnt: 0,
                                valid: 0,
                                end: 0,
                                new: 0,
                                re: 0,
                                totalLesson: 0,
                                realPrice: 0,
                            },
                        ];
                    }

                    if (moment(d.csbb_bill_year_month).format('YYYY') == this.yearDate) {
                        sum[id][0].totalPrice += parseInt(d.csbb_total_sale_price);
                        sum[id][0].newPrice += parseInt(d.csbb_sale_new_price);
                        sum[id][0].rePrice += parseInt(d.csbb_sale_renew_price);
                        sum[id][0].usePrice += parseInt(d.csbb_tick_use_price);
                        sum[id][0].remainCnt += parseInt(d.csbb_real_sale_price);
                        sum[id][0].valid += parseInt(d.csbb_less_valid_cnt);
                        sum[id][0].end += parseInt(d.csbb_less_finish_cnt);
                        sum[id][0].new += parseInt(d.csbb_sale_new_cnt);
                        sum[id][0].re += parseInt(d.csbb_sale_renew_cnt);
                        sum[id][0].totalLesson += parseInt(d.csbb_less_total_cnt);
                        sum[id][0].realPrice += parseInt(d.csbb_real_sale_price);
                    }
                    if (moment(d.csbb_bill_year_month).format('YYYY') == this.prevYearDate) {
                        sum[id][1].totalPrice += parseInt(d.csbb_total_sale_price);
                        sum[id][1].newPrice += parseInt(d.csbb_sale_new_price);
                        sum[id][1].rePrice += parseInt(d.csbb_sale_renew_price);
                        sum[id][1].usePrice += parseInt(d.csbb_tick_use_price);
                        sum[id][1].remainCnt += parseInt(d.csbb_real_sale_price);
                        sum[id][1].valid += parseInt(d.csbb_less_valid_cnt);
                        sum[id][1].end += parseInt(d.csbb_less_finish_cnt);
                        sum[id][1].new += parseInt(d.csbb_sale_new_cnt);
                        sum[id][1].re += parseInt(d.csbb_sale_renew_cnt);
                        sum[id][1].totalLesson += parseInt(d.csbb_less_total_cnt);
                        sum[id][1].realPrice += parseInt(d.csbb_real_sale_price);
                    }
                }
                console.log('====', sum);

                let keys = Object.keys(sum); //아이디배열
                console.log(keys);

                this.staffStatList = [];
                for (let k of keys) {
                    this.staffStatList.push(sum[k]);
                }

                console.log('list', this.staffStatList);
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },

        //직원급여 올해
        async onMonthStaffBill() {
            try {
                this.billStatus = this.signStatus();
                if (this.billStatus == 'X') {
                    this.staffStatList = [];
                    return false;
                } else {
                    const thisYear = await this.getMonthStaffBill(this.yearDate);
                    const prevYear = await this.getMonthStaffBill(this.prevYearDate);
                    console.log('도움', thisYear.data, prevYear.data);
                    this.staffTotalStat(thisYear.data, prevYear.data);
                }
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        //직원급여 조회 api
        getMonthStaffBill(year) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/year/staff-bill`, {
                params: {
                    year: year,
                    status: this.billStatus,
                },
            });
        },
        signStatus() {
            if (this.sign == true && this.resign == true) {
                //this.checkStaff =[]; //초기화처리
                return 'T';
            } else if (this.sign == true) {
                //this.checkStaff =[]; //초기화처리
                return 'I';
            } else if (this.resign == true) {
                //this.checkStaff =[]; //초기화처리
                return 'O';
            } else if (this.sign == false && this.resign == false) {
                return 'X';
            }
        },

        // 월간 보고서 엑셀 다운로드 기능
        execlDownload() {
            const wb = XLSX.utils.book_new();
            const monthReportDataWS = this.getMonthReportDataWS();
            const staffStatListWS = this.getStaffStatListWS();

            XLSX.utils.book_append_sheet(wb, monthReportDataWS, '월간보고서');
            XLSX.utils.book_append_sheet(wb, staffStatListWS, '직원');
            XLSX.writeFile(wb, '월간보고서.xlsx');
        },

        // 월간 보고서의 세부 내용을 다루는 부분
        getMonthReportDataWS() {
            let excelDownloadArray = [
                ['상담'],
                ['', '전화', '방문', '기타', '총 상담수'],
                [
                    this.yearDate,
                    numberFormat(Number(this.consult.thisMonth.tel)),
                    numberFormat(Number(this.consult.thisMonth.visit)),
                    numberFormat(Number(this.consult.thisMonth.etc)),
                    numberFormat(Number(this.consultTotal2)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.consult.prevMonth.tel)),
                    numberFormat(Number(this.consult.prevMonth.visit)),
                    numberFormat(Number(this.consult.prevMonth.etc)),
                    numberFormat(Number(this.consultTotal)),
                ],
                [],
                ['매출'],
                ['전체 수익 현황'],
                ['', '이용권 수입', '일반수입', '환불', '매출합계'],
                [
                    this.yearDate,
                    numberFormat(Number(this.price.thisMonth.ticketIncome)),
                    numberFormat(Number(this.price.thisMonth.income)),
                    numberFormat(Number(this.price.thisMonth.refund)),
                    numberFormat(Number(this.saleTotalThisMonth)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.price.prevMonth.ticketIncome)),
                    numberFormat(Number(this.price.prevMonth.income)),
                    numberFormat(Number(this.price.prevMonth.refund)),
                    numberFormat(Number(this.saleTotalPrevMonth)),
                ],
                ['', '고정지출', '변동지출', '급여', '지출합계', '영업이익'],
                [
                    this.yearDate,
                    numberFormat(Number(this.price.thisMonth.fix)),
                    numberFormat(Number(this.price.thisMonth.var)),
                    numberFormat(Number(this.price.thisMonth.salary)),
                    numberFormat(Number(this.saleTotalThisMonth1)),
                    numberFormat(Number(this.thisMonthRealPrice)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.price.prevMonth.fix)),
                    numberFormat(Number(this.price.prevMonth.var)),
                    numberFormat(Number(this.price.prevMonth.salary)),
                    numberFormat(Number(this.saleTotalPrevMonth1)),
                    numberFormat(Number(this.prevMonthRealPrice)),
                ],
                ['', '이용권 소진금액', '이용권 잔여금액'],
                [
                    this.yearDate,
                    numberFormat(Number(this.price.thisMonth.used)),
                    numberFormat(Number(this.price.thisMonth.remain)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.price.prevMonth.used)),
                    numberFormat(Number(this.price.prevMonth.remain)),
                ],
                [],
                ['신규 / 재등록 현황'],
                ['', '신규건수', '신규매출', '재등록건수', '재등록매출'],
                [
                    this.yearDate,
                    numberFormat(Number(this.contractType.thisMonth.newContract)),
                    numberFormat(Number(this.contractType.thisMonth.newPrice)),
                    numberFormat(Number(this.contractType.thisMonth.reContract)),
                    numberFormat(Number(this.contractType.thisMonth.rePrice)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.contractType.prevMonth.newContract)),
                    numberFormat(Number(this.contractType.prevMonth.newPrice)),
                    numberFormat(Number(this.contractType.prevMonth.reContract)),
                    numberFormat(Number(this.contractType.prevMonth.rePrice)),
                ],
                [],
                ['결제수단별 상품매출(이용권 수입 + 일반 수입)'],
                ['', '핏페이', '카드', '현금', '계좌', '기타', '합계', '마일리지 사용'],
                [
                    this.yearDate,
                    numberFormat(Number(this.payType.thisMonth.fitpay)),
                    numberFormat(Number(this.payType.thisMonth.card)),
                    numberFormat(Number(this.payType.thisMonth.cash)),
                    numberFormat(Number(this.payType.thisMonth.bank)),
                    numberFormat(Number(this.payType.thisMonth.etc)),
                    numberFormat(Number(this.payTypeTotal2)),
                    numberFormat(Number(this.payType.thisMonth.mileage)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.payType.prevMonth.fitpay)),
                    numberFormat(Number(this.payType.prevMonth.card)),
                    numberFormat(Number(this.payType.prevMonth.cash)),
                    numberFormat(Number(this.payType.prevMonth.bank)),
                    numberFormat(Number(this.payType.prevMonth.etc)),
                    numberFormat(Number(this.payTypeTotal)),
                    numberFormat(Number(this.payType.prevMonth.mileage)),
                ],
                [],
                ['이용권 구분별 매출현황'],
                ['', '개인', '듀엣', '오티', '그룹', '쿠폰', '회원권', '운동복', '패키지', '합계'],
                [
                    this.yearDate,
                    numberFormat(Number(this.ticketType.thisMonth.person)),
                    numberFormat(Number(this.ticketType.thisMonth.duet)),
                    numberFormat(Number(this.ticketType.thisMonth.ot)),
                    numberFormat(Number(this.ticketType.thisMonth.group)),
                    numberFormat(Number(this.ticketType.thisMonth.coupon)),
                    numberFormat(Number(this.ticketType.thisMonth.ticket)),
                    numberFormat(Number(this.ticketType.thisMonth.sport)),
                    numberFormat(Number(this.ticketType.thisMonth.pakage)),
                    numberFormat(Number(this.ticketTypeTotal2)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.ticketType.prevMonth.person)),
                    numberFormat(Number(this.ticketType.prevMonth.duet)),
                    numberFormat(Number(this.ticketType.prevMonth.ot)),
                    numberFormat(Number(this.ticketType.prevMonth.group)),
                    numberFormat(Number(this.ticketType.prevMonth.coupon)),
                    numberFormat(Number(this.ticketType.prevMonth.ticket)),
                    numberFormat(Number(this.ticketType.thisMonth.sport)),
                    numberFormat(Number(this.ticketType.prevMonth.pakage)),
                    numberFormat(Number(this.ticketTypeTotal)),
                ],
                [],
                ['환불현황'],
                ['', '총 건수', '금액'],
                [
                    this.yearDate,
                    numberFormat(Number(this.refund.thisYear.cnt)),
                    numberFormat(Number(this.refund.thisYear.price)),
                ],
                [
                    this.prevYearDate,
                    numberFormat(Number(this.refund.prevYear.cnt)),
                    numberFormat(Number(this.refund.prevYear.price)),
                ],
            ];

            let dataWS = XLSX.utils.aoa_to_sheet(excelDownloadArray);

            // cell width 설정
            let wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            return dataWS;
        },

        // 직원 Work Sheet 생성하는 함수
        getStaffStatListWS() {
            let excelDownloadArray = [];
            let wscols = [];

            this.staffStatList.forEach((m) => {
                let temp = {};
                temp['직원명'] = m.csbb_center_staff_nm;
                temp['년'] = m.yaer;
                temp['총 매출'] = numberFormat(Number(m.csbb_total_sale_price));
                temp['신규매출'] = numberFormat(Number(m.csbb_sale_new_price));
                temp['재등록 매출'] = numberFormat(Number(m.csbb_sale_renew_price));
                temp['소진금액'] = numberFormat(Number(m.csbb_tick_use_price));
                temp['잔여금액'] = numberFormat(Number(m.csbb_real_sale_price));
                temp['유효건수'] = numberFormat(Number(m.csbb_less_valid_cnt));
                temp['종료건수'] = numberFormat(Number(m.csbb_less_finish_cnt));
                temp['신규건수'] = numberFormat(Number(m.csbb_sale_new_cnt));
                temp['재등록 건수'] = numberFormat(Number(m.csbb_sale_renew_cnt));
                temp['총 수업 수'] = numberFormat(Number(m.csbb_less_total_cnt));
                temp['차인 지급액'] = numberFormat(Number(m.csbb_real_sale_price));

                excelDownloadArray.push(temp);
                wscols.push({ wch: 12 });
            });

            let dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            dataWS['!cols'] = wscols;

            return dataWS;
        },
    },
};
</script>
<style lang="scss"></style>
